import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { assetNameToId } from '../assetLinkingUtil';
import { Link } from 'react-router-dom';


interface AssetsSuppliersCellProps {
  items: string[];
}

const AssetsSuppliersCell: React.FC<AssetsSuppliersCellProps> = ({ items }) => {
  const [expanded, setExpanded] = useState(false);
  const [nameToId, setNameToId] = useState<Record<string, string>>({});
  const [loading, setLoading] = useState(true);

  React.useEffect(() => {
    let mounted = true;
    async function fetchIds() {
      // Only fetch for displayed items
      const unique = Array.from(new Set(items));
      const entries = await Promise.all(
        unique.map(async name => [name, await assetNameToId(name)] as [string, string | null])
      );
      if (mounted) {
        setNameToId(Object.fromEntries(entries.filter(([, id]) => !!id) as [string, string][]));
        setLoading(false);
      }
    }
    fetchIds();
    return () => { mounted = false; };
  }, [items.join(',')]);

  if (!items || items.length === 0) return null;
  const displayItems = expanded ? items : items.slice(0, 2);

  return (
    <div className="flex flex-col gap-1">
      {displayItems.map((item, i) => {
        const id = nameToId[item];
        return id ? (
          <span key={i} className="truncate text-xs bg-[#fafafa] px-2 py-1 rounded max-w-full">
            <Link to={`/assetdetail/${id}`} target="_blank" rel="noopener noreferrer" className="text-primary">
              {item}
            </Link>
          </span>
        ) : (
          <span key={i} className="truncate text-xs bg-[#fafafa] px-2 py-1 rounded max-w-full">{item}</span>
        );
      })}
      {items.length > 2 && (
        <button
          className="text-xs text-primary underline mt-1 focus:outline-none"
          onClick={() => setExpanded(e => !e)}
        >
          {expanded ? 'Show less' : `Show ${items.length - 2} more`}
        </button>
      )}
    </div>
  );
};

export default AssetsSuppliersCell;
